import React from "react";
import { getSurveyAnswerValue } from "../../Utils";
import Text from "../../../components/Text";
import Messages from "../../Messages";
import "./SurveyAnswersSummary.scss";

function getAnswerDisplay(question) {
  const answers = question.answers || [];

  if (!answers.length || !answers[0]) {
    return null;
  }

  if (question.isMultipleAnswersPermitted && answers.length > 1) {
    const values = answers
      .map((ans) => getSurveyAnswerValue(question.type, ans))
      .filter(Boolean);
    return values.length > 0 ? values.join(", ") : null;
  }

  return getSurveyAnswerValue(question.type, answers[0]);
}

function shouldShowQuestion(question) {
  if (question.type === "DISPLAY") return false;
  if (question.hide) return false;
  if (question.enableWhen && question.enableWhen.hasAnswer === false)
    return false;
  return true;
}

const SurveyAnswersSummary = ({ survey }) => {
  if (!survey || !survey.items) return null;

  const groups = survey.items;

  return (
    <div className="survey-answers-summary">
      <p className="survey-answers-summary-subtitle">
        <Text content={Messages.review_your_answers} />
      </p>
      {groups.map((group, gIndex) => {
        const visibleQuestions = (group.items || []).filter(shouldShowQuestion);
        if (visibleQuestions.length === 0) return null;

        return (
          <div key={group.id || gIndex} className="survey-answers-summary-group">
            {group.text && (
              <div className="survey-answers-summary-group-header">
                {group.text}
              </div>
            )}
            {visibleQuestions.map((question, qIndex) => {
              const answerDisplay = getAnswerDisplay(question);
              const hasAnswer = answerDisplay !== null && answerDisplay !== "";

              return (
                <div
                  key={question.id || qIndex}
                  className="survey-answers-summary-item"
                >
                  <div className="survey-answers-summary-question">
                    {question.prefix && (
                      <span className="survey-answers-summary-prefix">
                        {question.prefix}{" "}
                      </span>
                    )}
                    {question.text}
                  </div>
                  <div
                    className={
                      hasAnswer
                        ? "survey-answers-summary-answer"
                        : "survey-answers-summary-unanswered"
                    }
                  >
                    {hasAnswer ? (
                      answerDisplay
                    ) : (
                      <Text content={Messages.question_not_answered} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default SurveyAnswersSummary;
